export enum ProjectStatus {
  // ESTIMATE = "ESTIMATE",
  PROPOSAL = "PROPOSAL",
  ACTIVE = "ACTIVE",
  DONE = "DONE",
  // ON_HOLD = "ON_HOLD",
  CANCELLED = "CANCELLED",
  PRICING = "PRICING",
}
